export default {
  LIST(state, data) {
    state.uzAsboLists = data
  },
  GET(state, data) {
    state.uzAsboList = data
  },
  MONTHLY(state, data) {
    state.monthly = data
  },
  FRESH(state) {
    state.uzAsboList = {
      id: null,
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      items: [],
    }
  },
}
